<template>
  <div class="mod-list">
    <a-table :columns="columns" :data-source="dataBySort" row-key="index" :locale="locale" :pagination="data.pagination" :loading="loading" @change="onChange">
      <a slot="couponNumber" slot-scope="text, record" @click.prevent="onShowDetail(record)">{{ text }}</a>
      <span slot="couponType" slot-scope="text">{{ text | couponType }}</span>
      <span slot="couponQuata" slot-scope="text">{{ text }}（含以上）</span>
    </a-table>
  </div>
</template>

<script>
import _ from 'lodash'

const columns = [
  {
    dataIndex: 'indexNew',
    title: '序号',
    scopedSlots: { customRender: 'indexNew' }
  },
  {
    dataIndex: 'couponNumber',
    title: '优惠券号',
    scopedSlots: { customRender: 'couponNumber' }
  },
  {
    dataIndex: 'couponType',
    title: '优惠券类型',
    scopedSlots: { customRender: 'couponType' }
  },
  {
    dataIndex: 'couponAmount',
    title: '面值'
  },
  {
    dataIndex: 'couponQuata',
    title: '产品使用限额',
    scopedSlots: { customRender: 'couponQuata' }
  },
  {
    dataIndex: 'validity',
    title: '优惠券有效期'
  }
]

export default {
  props: {
    data: {
      type: Object,
      default () {
        return {
          list: [],
          pagination: {
            current: 1,
            pageSize: 10,
            total: 0
          }
        }
      }
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    dataBySort () {
      const list = _.orderBy(this.data.list, ['validEndDate', 'couponAmount'], ['asc', 'desc'])
      list.forEach((element, index) => {
        element.indexNew = index + 1
      })
      return list
    }
  },
  data () {
    return {
      columns,
      locale: {
        emptyText: '暂无数据'
      }
    }
  },
  methods: {
    onChange (pagination) {
      this.$emit('change', pagination)
    },
    onShowDetail (record) {
      this.$emit('detail', record)
    }
  }
}
</script>
